'use client';

import { Session } from 'next-auth';
import { useEffect } from 'react';

import CartService from '@bytel/magicart';

import { getOfferWallData } from '@services/categories';

import { QUOTE_TYPES } from '@app-types/cart';
import { CategoryListType, CategoryPlanType } from '@app-types/plan';
import { ProductType } from '@app-types/product';

import { getCart } from '@helpers/cart';
import { PremiumSubCategories, SimoSubCategories } from '@helpers/offer-wall';

import { SAPIC_X_VERSION } from '@constants/api';
import { PlanTypeId } from '@constants/plan';

import { getQuotePayload } from '@home-mobile/helpers';

export function useInitPhoneInCart(
    setAllCategoryList: (categoryList: CategoryListType) => void,
    setCategoryListToDisplay: (categoryList: CategoryListType) => void,
    filterCategories: (categoryCode: string, list: CategoryListType) => CategoryPlanType[],
    currentCategory: PlanTypeId,
    isClientBbox: boolean,
    session?: Session | null,
) {
    useEffect(() => {
        getCart().then(async (cart: CartService) => {
            const phone = cart.cart.quotes
                ?.find((quote) => quote.context.id === QUOTE_TYPES.ACQUISITION)
                ?.products.find((product) => product.data.type_id === ProductType.PHONE_SIMPLE);
            if (phone) {
                const quotes = getQuotePayload(isClientBbox, phone.gencode, SAPIC_X_VERSION.V4, !!session?.user);
                const categoryList = await getOfferWallData(
                    [...PremiumSubCategories, ...SimoSubCategories],
                    { cart: { quotes } },
                    session,
                    SAPIC_X_VERSION.V4,
                );
                setAllCategoryList(categoryList);
                const filteredCategories = filterCategories(currentCategory, categoryList);
                setCategoryListToDisplay(filteredCategories);
            }
        });
    }, [isClientBbox]);
}
